import { Markdown } from '@rich-products-corp/primitives-richproducts';

export const GlobalMessagingBanner = (props) => {
  return (
    <div className="bg-primary-800 p-3.5 text-center text-sm text-white">
      {props.data?.message ? <Markdown>{props.data?.message}</Markdown> : null}
    </div>
  );
};
